// src/constants/learningConstants.js
// Learning Feature Constants

export const CourseCategory = {
  TECHNOLOGY: 'Technology',
  BUSINESS: 'Business',
  CREATIVE: 'Creative',
  HEALTH: 'Health & Wellness',
  EDUCATION: 'Education',
  PERSONAL: 'Personal Development',
  PROFESSIONAL: 'Professional Skills',
  LANGUAGE: 'Language'
};

export const CourseDifficulty = {
  BEGINNER: 'Beginner',
  INTERMEDIATE: 'Intermediate',
  ADVANCED: 'Advanced',
  EXPERT: 'Expert'
};

export const BlockType = {
  TEXT: 'TEXT',
  VIDEO: 'VIDEO',
  IMAGE: 'IMAGE',
  QUIZ: 'QUIZ',
  ASSESSMENT: 'ASSESSMENT',
  FILE: 'FILE',
  EMBED: 'EMBED'
};

export const AssessmentType = {
  MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
  TRUE_FALSE: 'TRUE_FALSE',
  SHORT_ANSWER: 'SHORT_ANSWER',
  ESSAY: 'ESSAY',
  MATCHING: 'MATCHING',
  FILL_BLANK: 'FILL_BLANK'
};